import { IFormularioHazard, IListaHazardRequest, IPersonaReporte } from "../../Interfaces/hazard/IHazard";
import { fetchListVerificacion } from "../http-common";

const Hazard = "Hazard";

const RegistrarFormulario = (request:IFormularioHazard) => {
    return fetchListVerificacion.post(`${Hazard}/RegistrarFormulario`, request);
};
const ListarFormularios = (request:IListaHazardRequest) => {
    return fetchListVerificacion.post(`${Hazard}/ListarFormularios`, request);
};
const ComboPersonas = (request:IPersonaReporte,controller = new AbortController()) => {
    return fetchListVerificacion.get(`${Hazard}/PersonaReporte`, {
        params: request,
        signal: controller.signal,
    });
};
const GetInfoPersonaHazard=()=>{
    return fetchListVerificacion.get(`${Hazard}/InfoPersonaHazard`)
}
const CargaReporteFormularioHazard=(data:any)=>{
    return fetchListVerificacion.get(`${Hazard}/ReporteExcelFormularioHazard`, {
        responseType: "blob"})
}
const HazardService = {
    RegistrarFormulario,ListarFormularios,ComboPersonas,CargaReporteFormularioHazard,
    GetInfoPersonaHazard
}

export { HazardService };